class CartaSiniestro {
    constructor({
        intIdCartaEnviada,
        codSeguimiento,
        estado,
        aut,
        ar,
        modelo,
        idCartaEnviada,
        idCarta,
        fechaGeneracion,
        fechaEnvio,
        fechaNovedad,
        lote,
    }) {
        this.intIdCartaEnviada = intIdCartaEnviada
        this.codSeguimiento = codSeguimiento
        this.estado = estado
        this.aut = aut
        this.ar = ar
        this.modelo = modelo
        this.idCartaEnviada = idCartaEnviada
        this.idCarta = idCarta
        this.fechaGeneracion = fechaGeneracion
        this.fechaEnvio = fechaEnvio
        this.fechaNovedad = fechaNovedad
        this.lote = lote
    }
}

export default CartaSiniestro
